import { createSelector } from "reselect";

export const selectTerminState = createSelector(
    [(state) => state]
    , (state) => state?.termin
)

export const selectICalTermineCounters = createSelector([selectTerminState], state => state?.iCalTermineCounters)
export const selectImportedICalTermineCount = createSelector(
    [selectICalTermineCounters]
    , counters => (counters?.success || 0) + (counters?.failed || 0) + (counters?.skipped || 0)
)
export const selectIsImportingICalTermine = createSelector([selectTerminState], state => Boolean(state?.iCalTermineImporting))
export const selectIsImportingICalResetRequested = createSelector([selectTerminState], state => Boolean(state?.importICalResetRequested))
